<template>
    <v-dialog v-model="isVisible" max-width="600">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Agregar Nuevo Tipo de Dato General
			</p-header-dialog>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
				<label :style="`color:${$appColors.info}; width: 100%;`">Nombre:
					<v-text-field
						label="Nombre"
						solo
						hide-details
						class="input-text"
						v-model="item.name"
					></v-text-field>
					<span
						v-if="$v.item.name.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El Nombre es requerido
					</span>
				</label>
				<label :style="`color:${$appColors.info}; width: 100%;`">Código:
					<v-text-field
						label="Código"
						solo
						hide-details
						:disabled="item.flagEdit"
						class="input-text"
						v-model="item.code"
					></v-text-field>
					<span
						v-if="$v.item.code.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El Código es requerido
					</span>
				</label>
			</section>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					:disabled="fieldsNone"
					type="primary"
					@click="saveNewItem"
					> Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'add-data-general-to-type-data-dialog',
	created() {
		if (this.typeData.flagEdit) {
			this.item.name = this.typeData.name;
			this.item.code = this.typeData.code;
			this.item.flagEdit = this.typeData.flagEdit;
		} else {
			this.item.name = null;
			this.item.code = null;
			this.item.flagEdit = this.typeData.flagEdit;
		}
	},
	data() {
		return {
			item: {
				name: null,
				code: null,
			},
		};
	},
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
			this.item = {
				name: null,
				code: null,
			};
		},
		saveNewItem() {
			this.$emit('addNewItem', this.item);
			this.close();
			this.item = {
				name: null,
				code: null,
			};
		},
	},
	computed: {
		fieldsNone() {
			return !this.item.name || !this.item.code;
		},
	},
	props: {
		typeData: {
			type: Object,
			default: () => {},
		},
		isVisible: {
			type: Boolean,
			default: false,
		},
	},
	validations() {
		return {
			item: {
				name: { required },
				code: { required },
			},
		};
	},
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/configuration/general-data/add-type-data-dialog.vue